function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("title", null, "VF_align_left"), /*#__PURE__*/React.createElement("path", {
  d: "M28.3 42.5h226.8v28.3H28.3zM28.3 99.2h191.3v28.3H28.3zM28.3 212.6h127.6v28.3H28.3zM28.3 155.9h155.9v28.3H28.3z"
})));